const APP_VISIT_COUNT_KEY = 'app_visit_count'

export function getAppVisitCount(): number {
  try {
    return Number(localStorage.getItem(APP_VISIT_COUNT_KEY)) || 0
  } catch {
    return 0
  }
}

export function countAppVisit(): void {
  try {
    localStorage.setItem(APP_VISIT_COUNT_KEY, String(getAppVisitCount() + 1))
  } catch {
    // Storage unavailable (private mode): the install banner never shows.
  }
}
